"use strict";
/**
 * Universally unique identifiers (UUIDs) are needed in KILT to uniquely identify specific information.
 *
 * UUIDs are used for example in [[RequestForAttestation]] to generate hashes.
 *
 * @packageDocumentation
 * @module UUID
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.generate = void 0;
const uuid_1 = require("uuid");
const Crypto_1 = require("./Crypto");
/**
 * Generates a H256 compliant UUID.
 *
 * @returns The hashed uuid.
 */
function generate() {
    return Crypto_1.hashStr(uuid_1.v4());
}
exports.generate = generate;
exports.default = {
    generate,
};
